import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../../contex/AuthProvider';
import MyProductsDetails from './Myproductsdetails/MyProductsDetails';
import toast from 'react-hot-toast';
import { useQuery } from '@tanstack/react-query';
import { async } from '@firebase/util';
import Loading from '../../Home/Share/Loading/Loading';
const MyProducts = () => {
    const { user, logOut } = useContext(AuthContext);
    const { data: products, isLoading, refetch } = useQuery({
        queryKey: ['products'],
        queryFn: async () => {
            const res = await fetch(`https://assignment-12-server-imraniium-su.vercel.app/mybooks?email=${user?.email}`);
            const data = await res.json();
            return data;
        }
    });

    if (isLoading) {
        return <Loading></Loading>
    }


    const handleDelete = (id) => {
        const proceed = window.confirm('Are you sure, you want to cancel this ');
        if (proceed) {
            fetch(`https://assignment-12-server-imraniium-su.vercel.app/books/${id}`, {
                method: 'DELETE',
                headers: {
                    authorization: `bearer ${localStorage.getItem('accessToken')}`
                }
            })
                .then(res => {
                    res.json()
                })
                .then(data => {
                    refetch()
                    toast.success('Successfully delete');
                    console.log(data);
                })
        }
    }

    const handleAdvertise = (id) => {
        const proceed = window.confirm('Are you sure, you want to verify this ');
        if (proceed) {
            fetch(`https://assignment-12-server-imraniium-su.vercel.app/books/advertise/${id}`, {
                method: 'PATCH',
                headers: {
                    'content-type': 'application/json',
                    authorization: `bearer ${localStorage.getItem('accessToken')}`
                },
                body: JSON.stringify({
                    isAdvertise: true
                }),
            })
                .then(res =>
                    res.json()
                )
                .then(data => {
                    console.log(data);
                    refetch();
                    toast.success('Successfully verified');
                })
        }
    }

    return (
        <div>
            {products.length}
            <h3 className='text-3xl font-semibold mb-5 text-center'>My Products</h3>


            <div className="overflow-x-auto m-3">
                <table className="table w-full">

                    <thead>
                        <tr>
                            <th></th>
                            <th>Name</th>
                            <th>Price</th>
                            <th>Advertise</th>
                            <th>sales status</th>
                            <th>Delete</th>
                        </tr>
                    </thead>
                    <tbody>

                        {
                            products &&
                            products?.map((book, i) => <tr key={book._id}>
                                <th>{i + 1}</th>
                                <td>{book.nameTitle}</td>
                                <td>{book.resalePrice}</td>
                                <td>
                                    {
                                        book.isAdvertise ? <p>Advertised</p> : <label>
                                            <button onClick={() => handleAdvertise(book._id)} className='btn btn-primary btn-sm'>Advertised</button>
                                        </label>
                                    }
                                </td>
                                <td>
                                    {
                                        book.isConfirm ? <p>Sold</p> : <label>
                                            <button className='btn btn-primary btn-sm'>Available</button>
                                        </label>
                                    }
                                </td>
                                <td>
                                    <label>
                                        <button onClick={() => handleDelete(book._id)} className='btn btn-primary btn-sm'>Delete</button>
                                    </label>
                                </td>


                            </tr>
                            )
                        }
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default MyProducts;